<template>
  <div class="notice">
    <!-- <div class="banner">
      <img src="../../assets/banner.png" alt="">
    </div> -->
 
    <div class="notice_content container">
      <div class="notice_title">
        <span class="iconfont iconliebiao"></span>通知公告
      </div>
      <div class="notice_list">
        <el-row :gutter="20" v-if="activityList.length>0">
          <el-col :xs="12" :sm="12" :md="12" :lg="12" :xl="12" v-for="item in activityList" :key="item.id">
            <div class="list_item" @click="activityDetail(item.id)">
              <div class="item_left">
                <img :src="baseurl+item.img" alt="">
              </div>
              <div class="item_right">
                <div class="item_right_title e-line-1">
                  {{ item.title }}
                </div>
                <div class="item_right_content e-line-2">
                  {{ item.depict }}
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row v-else :gutter="20">
            <el-col>
                <div style="line-height:300px;text-align:center;font-size:18px">
                    暂无数据
                </div>
            </el-col>
        </el-row>
      </div>
      <div class="pagination">
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :current-page="dataform.page"
          @current-change="handleCurrentChange"
          @prev-click="getActivityList"
          @next-click="getActivityList"
          >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'notice',
   data () {
    return {
      dataform: {
        page: 1,
        limit: 10,
        type:39,
        status:2
      },
      total: 0,
      activityList: '',
      baseurl:this.$baseurl
    }
  },
  mounted () {
    this.getActivityList()
  },
  methods: {
    handleCurrentChange(v) {
      this.dataform.page = v
      this.getActivityList()
    },
    activityDetail(id) {
      this.$router.push({ path: '/noticeDetail', query: { id }})
    },
    async getActivityList() {
        console.log( this.dataform)
      let { data: { code, data }} = await this.$http.get('/api/information/page', { params: this.dataform})
      console.log(data);
      if(code != 0) return
      this.activityList = data.list
      this.total = data.total
    }
  }
}
</script>

<style lang="scss" scoped>
.notice {
  .banner {
    img {
      width: 100%;
      height: 100%;
    }
  }
  .notice_content {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
    .notice_title {
      font-size: 24px;
      line-height: 2;
      .iconliebiao {
        font-size: 28px;
        color: #3498db;
        margin-right: 5px;
      }
    }
    .notice_list { 
      .list_item {
        position: relative;
        top: 0;
        cursor: pointer;
        display: flex;
        margin: 10px 0;
        border: 2px solid #E4E7ED;
        padding: 10px;
        border-radius: 7px;
        transition: .2s ease-out;
        height: 85px;
       &:hover {
          box-shadow: 2px 2px 2px #C0C4CC;
          top: -3px
        }
        .item_left {
          margin-right: 10px;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 50px;
            height: 50px;
            object-fit: contain;
          }
        }
        .item_right {
          line-height: 1.5;
          .item_right_title {
            line-height: 2;
            font-size: 18px;
            font-weight: 700;
            color: #303133;
          }
          .item_right_content {
            font-size: 16px;
            color: #606266;
          }
        }
      }
    }
    .pagination {
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 20px 0 30px 0;
    }
  }
  
}
</style>